import { useRouter } from 'next/router';
import { images } from '../../Constants/ImageUrls';
import { BreadCrumbSection } from '../Product/RatingandReviews/styled';
import AnchorCoverTag from '../StoreHomePage/AnchorCoverTag';

import React from 'react';
import { getPublicUrl } from '../../appconfig';

const ColorPageBreadCrumbs = (props) => {
  const { lastCrumb } = props;
  const router = useRouter();
  return (
    <BreadCrumbSection newUI={true}>
      <p className="blue">
        <AnchorCoverTag
          url={getPublicUrl()}
          callback={() => {
            router.push(getPublicUrl());
          }}
        >
          HOME
        </AnchorCoverTag>
      </p>

      <img src={images.arrowDownForward} alt="" />
      {lastCrumb ? (
        <>
          <p className=" blue lastcrumb">
            <AnchorCoverTag
              url="/coloring-pages-for-kids"
              callback={() => {
                router.push('/coloring-pages-for-kids');
              }}
            >
              COLORING PAGES FOR KIDS{' '}
            </AnchorCoverTag>
          </p>

          <img src={images.arrowDownForward} alt="" />
          <p className=" light lastcrumb">{lastCrumb}</p>
        </>
      ) : (
        <p className=" light lastcrumb">COLORING PAGES FOR KIDS</p>
      )}
    </BreadCrumbSection>
  );
};

export default ColorPageBreadCrumbs;
